import { useEffect } from 'react';

export function useTimer(condition: boolean, callback: any, delay: number) {
    useEffect(() => {
        if (condition) {
            const timer = setTimeout(() => {
                callback();
            }, delay);

            return () => clearTimeout(timer);
        }
    }, [condition, callback, delay]);
}